import _DxTreeMap from "devextreme-react/tree-map";
// Vite 8 CJS interop: with "type": "module", default import may resolve to module.exports (namespace object)
const DxTreeMap = ((_DxTreeMap as unknown as Record<string, unknown>)["default"] ?? _DxTreeMap) as typeof _DxTreeMap;
import React from "react";
import { ChartCore } from "./ChartCore.tsx";
import type { ChartProps } from "./ChartProps.ts";

export class TreeMap extends React.Component<ChartProps> {
  override render(): React.ReactNode {
    return (
      <ChartCore {...this.props}>
        <DxTreeMap
          ref={(ref) => this.props.exportFunc(ref?.instance.exportTo.bind(ref.instance))}
          dataSource={this.props.dataSource}
          valueField={this.props.values[0]?.config.guid || ""}
          labelField={this.props.args[0]?.meta.name || ""}
        >
          {/* <Tooltip enabled={true} customizeTooltip={customizeTooltip} /> */}
        </DxTreeMap>
      </ChartCore>
    );
  }
}

export default TreeMap;
